const yodaSiteComponents = {
    IrisPage: {
        importFn: () => import('yodaSiteComponents/IrisPage'),
        path: 'yodaSiteComponents/IrisPage',
        type: 'class',
        isSSR: true,
    },
    Loading: {
        importFn: () => import('yodaSiteComponents/Loading'),
        path: 'yodaSiteComponents/Loading',
        type: 'class',
        isSSR: false
    },
};

module.exports = { yodaSiteComponents };
